// import React from 'react'
import { createMuiTheme } from '@material-ui/core/styles'

export const skappTheme = createMuiTheme({
    typography: {
        htmlFontSize: 16,
        fontFamily: "'aileron', sans-serif",
        body1: {

            lineHeight: '1.25'
        }
    },
})